import { connect } from 'react-redux';
import React from 'react';

import PageSelector from 'components/PageSelector';
import { getJournalPaging } from 'selectors';
import * as actions from 'actions';

const JournalPageSelector = (props) => <PageSelector {...props} />;

const mapStateToProps = (state) => getJournalPaging(state);

const mapDispatchToProps = (dispatch) => {
  return {
    onPrevClick: (currentPage) => {
      dispatch(actions.journalEntriesFetch(currentPage - 1));
    },
    onNextClick: (currentPage) => {
      dispatch(actions.journalEntriesFetch(currentPage + 1));
    },
    onPossiblePageUpdate: (newPossiblePage) => {
      dispatch(actions.journalEntriesUpdatePossiblePage(newPossiblePage));
    },
    onPageUpdate: (newPage, pagesCount) => {
      if(newPage >= 1 && newPage <= pagesCount) {
        dispatch(actions.journalEntriesFetch(newPage));
      }
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(JournalPageSelector);



/** WEBPACK FOOTER **
 ** ./src/members/Main/Journal/JournalPageSelector/index.js
 **/